"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ePod = exports.ePodDevice = exports.ePodProfile = void 0;
/* eslint-disable new-cap */
/* eslint-disable no-underscore-dangle */
var DeviceCharacteristic_1 = require("../common/DeviceCharacteristic");
var BatDevice_1 = __importDefault(require("../common/BatDevice"));
exports.ePodProfile = {
    uuid: '6cd6c8b5-e378-0103-000a-1b9740683449',
    VAPING: {
        name: 'Vaping Service',
        uuid: '6cd6c8b5-e378-0103-000a-1b9740683449',
        characteristics: [
            {
                name: DeviceCharacteristic_1.VapingCharacteristics.DEVICE_INFORMATION,
                uuid: '6cd6c8b5-e378-0103-010a-1b9740683449',
            },
            { name: DeviceCharacteristic_1.VapingCharacteristics.TIME, uuid: '6cd6c8b5-e378-0103-020a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.BATTERY, uuid: '6cd6c8b5-e378-0103-030a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.LOCK, uuid: '6cd6c8b5-e378-0103-040a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS, uuid: '6cd6c8b5-e378-0103-060a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.FIND_MY_VAPE, uuid: '6cd6c8b5-e378-0103-090a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.LED, uuid: '6cd6c8b5-e378-0103-0a0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.CLOUD_CONTROL, uuid: '6cd6c8b5-e378-0103-0c0a-1b9740683449' },
            { name: DeviceCharacteristic_1.VapingCharacteristics.FACTORY_RESET, uuid: '6cd6c8b5-e378-0103-0b0a-1b9740683449' },
        ],
    },
    LOG: {
        name: 'Logging Service',
        uuid: '6cd6c8b5-e378-0103-000b-1b9740683449',
        characteristics: [
            { name: 'LAST_ERROR', uuid: '6cd6c8b5-e378-0103-010b-1b9740683449' },
            { name: 'LOG_RECORD', uuid: '6cd6c8b5-e378-0103-030b-1b9740683449' },
        ],
    },
    DFU: {
        name: 'Firmware Update Service',
        uuid: '0000fe59-0000-1000-8000-00805f9b34fb',
        characteristics: [
            { name: 'BUTTON_LESS', uuid: '8ec90003-f315-4f60-9fb8-838830daea50' },
            { name: 'CONTROL_POINT', uuid: '8ec90001-f315-4f60-9fb8-838830daea50' },
            { name: 'DFU_PACKET', uuid: '8ec90002-f315-4f60-9fb8-838830daea50' },
        ],
    },
};
var ePodDevice = /** @class */ (function (_super) {
    __extends(ePodDevice, _super);
    function ePodDevice() {
        return _super.call(this, exports.ePodProfile, 'ePod') || this;
    }
    return ePodDevice;
}(BatDevice_1.default));
exports.ePodDevice = ePodDevice;
exports.ePod = new ePodDevice();
